import { useStorage } from '@vueuse/core'
import { isDeepEqual } from 'remeda'

export type RecentNavigationItemType = 'team' | 'repository' | 'teamspace'

export interface RecentNavigationItem {
  label: string
  to: {
    name: string
    params: Record<string, string>
  }
}

const MAX_RECENT_ITEMS = 3
const recentItems = useStorage<RecentNavigationItem[]>('recent-navigation-items', [])

export default function () {
  function addRecentItem(item: RecentNavigationItem) {
    const itemAlreadyAtIndex = recentItems.value.findIndex(o => isDeepEqual(o, item))
    recentItems.value.unshift(item)
    if (itemAlreadyAtIndex !== -1) {
      // remove now duplicated item
      // + 1 offset because it has already been re-inserted at the start of the array with `.unshift` above
      recentItems.value.splice(itemAlreadyAtIndex + 1, 1)
    }
    recentItems.value = recentItems.value.slice(0, MAX_RECENT_ITEMS)
  }

  return {
    recentItems,
    addRecentItem,
  }
}
